import {
  CheckCircle2,
  AlertTriangle,
  XCircle,
  RefreshCw,
  GitBranch,
} from "lucide-react";

export const STATUS_CONFIG = {
  operational: {
    label: "Operational",
    bannerLabel: "All Systems Operational",
    bannerSubtitle: "All network sites are functioning normally.",
    Icon: CheckCircle2,
    bannerClass: "border-l-4 border-emerald-600 bg-emerald-50",
    bannerTextClass: "text-emerald-900",
    bannerIconClass: "text-emerald-600",
    badgeClass: "bg-emerald-50 text-emerald-700 border border-emerald-200",
    badgeIconClass: "text-emerald-500",
  },
  degraded: {
    label: "Degraded",
    bannerLabel: "Degraded Service",
    bannerSubtitle: "Some network links or devices are experiencing issues.",
    Icon: AlertTriangle,
    bannerClass: "border-l-4 border-amber-500 bg-amber-50",
    bannerTextClass: "text-amber-900",
    bannerIconClass: "text-amber-500",
    badgeClass: "bg-amber-50 text-amber-700 border border-amber-200",
    badgeIconClass: "text-amber-500",
  },
  failover: {
    label: "Failover",
    bannerLabel: "Degraded Service",
    bannerSubtitle: "Some network links or devices are experiencing issues.",
    Icon: GitBranch,
    bannerClass: "border-l-4 border-amber-500 bg-amber-50",
    bannerTextClass: "text-amber-900",
    bannerIconClass: "text-amber-500",
    badgeClass: "bg-blue-50 text-blue-700 border border-blue-200",
    badgeIconClass: "text-blue-500",
  },
  outage: {
    label: "Outage",
    bannerLabel: "Service Outage",
    bannerSubtitle: "One or more network sites are currently offline.",
    Icon: XCircle,
    bannerClass: "border-l-4 border-red-600 bg-red-50",
    bannerTextClass: "text-red-900",
    bannerIconClass: "text-red-600",
    badgeClass: "bg-red-50 text-red-700 border border-red-200",
    badgeIconClass: "text-red-500",
  },
  unknown: {
    label: "Checking\u2026",
    bannerLabel: "Checking Status",
    bannerSubtitle: "Fetching current network status, please wait.",
    Icon: RefreshCw,
    bannerClass: "border-l-4 border-zinc-300 bg-zinc-50",
    bannerTextClass: "text-zinc-600",
    bannerIconClass: "text-zinc-400",
    badgeClass: "bg-zinc-100 text-zinc-500 border border-zinc-200",
    badgeIconClass: "text-zinc-400",
  },
};


